import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PencilRuler } from "lucide-react";
import { AppShell } from "@/components/app/AppShell";
import { Spinner, EmptyState } from "@/components/common/Common";
import api from "@/lib/api";
import { IMG } from "@/lib/constants";

export default function AppStudio() {
  const [projects, setProjects] = useState(null);
  const nav = useNavigate();
  useEffect(() => { api.get("/projects").then(({ data }) => setProjects(data)); }, []);
  if (!projects) return <AppShell variant="home" title="Studio"><Spinner /></AppShell>;
  return (
    <AppShell variant="home" title="Sitepar Studio">
      <div className="mb-6"><h1 className="text-2xl font-bold text-sp-navy">Sitepar Studio</h1><p className="text-sm text-slate-500">Floor plans, 3D, elevations and GFC drawings — versioned per project.</p></div>
      {projects.length === 0 ? <EmptyState title="No projects yet" subtitle="Create a project to start uploading drawings." icon={PencilRuler} onAction={() => nav("/onboarding/home")} actionLabel="Create Project" /> :
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">{projects.map((p) => (
          <button key={p.id} onClick={() => nav(`/app/project/${p.id}?tab=drawings`)} data-testid={`studio-project-${p.id}`} className="text-left rounded-xl overflow-hidden border border-slate-200 bg-white sp-hover-card">
            <img src={IMG.blueprint} alt="" className="h-32 w-full object-cover" />
            <div className="p-4"><div className="font-semibold text-sp-navy">{p.name}</div><div className="text-xs text-slate-400">{p.location} · Open drawings</div></div>
          </button>
        ))}</div>}
    </AppShell>
  );
}
